<template>
  <div :style="{ height: iframeVisible ? 'auto' : '322px' }">
    <iframe
      v-if="iframeVisible"
      ref="taxiFrame"
      :src="`${taxiWidgetBaseUrl}/widget.html?cacheBust=${cacheBust}`"
      class="taxi-widget my-2"
      :style="`height: ${iframeHeight}px`"
      @load="initializeTaxiWidget"></iframe>
  </div>
</template>

<script>
import AccountApi from "@/services/account.api";
import taxi from "@/mixins/taxi";

export default {
  name: "TaxiWidget",
  props: {
    orderId: {
      type: String,
      required: true,
    },
    orderToken: {
      type: String,
      required: false,
    },
    orderAccountId: {
      type: String,
      required: false,
    },
    modalActive: {
      type: Boolean,
      default: false,
    },
    token: {
      type: String,
      required: true,
    },
  },
  mixins: [taxi],
  data() {
    return {
      initDelay: 200,
      iframeVisible: false,
      inDialog: true,
      whiteWidgetLoading: true,
      blockHeightChange: false,
    };
  },
  computed: {
    AccountModel() {
      return new AccountApi(this.tenantId, this.token);
    },
  },
  watch: {
    modalActive: {
      handler(newVal) {
        if (newVal) {
          this.blockHeightChange = true;
          this.iframeHeight = 300;
          this.handleFrameLoading({ visibility: true, white: this.whiteWidgetLoading });
          setTimeout(() => {
            this.blockHeightChange = false;
            this.handleFrameLoading({ visibility: false, white: this.whiteWidgetLoading });
          }, 500);
        }
      },
      immediate: true,
    },
  },
  methods: {
    updateOrder() {
      this.$emit("updateOrder");
    },
  },
  mounted() {
    setTimeout(() => {
      this.iframeVisible = true;
    }, this.initDelay);
  },
};
</script>
